const AppRouter = /** @type {const}*/ ({
  ROOT: {
    path: '/',
    options: {
      showDatePicker: true,
      showTeamPicker: true,
      iterationsPeriodOnly: false,
      showFilteredView: true
    }
  },
  LINK_ACCOUNT: {
    path: '/link-account'
  },
  OVERDUE: {
    path: '/overdue'
  },
  LOGIN: {
    path: '/login'
  },
  REGISTER: {
    path: '/register'
  },
  PAGE_ASSESS: {
    path: '/assessment'
  },
  PAGE_DASHBOARD: {
    path: '/dashboard',
    options: {
      showDatePicker: true,
      showTeamPicker: true,
      iterationsPeriodOnly: false,
      showFilteredView: true
    }
  },
  REPORTS: {
    path: '/reports',
    options: {
      showTeamPicker: true
    }
  },
  SETTINGS: {
    path: '/settings',
    options: {
      showTeamPicker: true
    }
  },
  CONFIGURATION: {
    path: '/settings/organization'
  },
  GENERAL: {
    path: '/settings/general'
  },
  GIT_SETTINGS: {
    path: '/settings/git'
  },
  REPOSITORIES: {
    path: '/settings/git/repositories'
  },
  GIT_INTEGRATION_MONITORING_RULES: {
    path: '/settings/git/monitoring-rules/:integrationId',
    getLink: integrationId =>
      `/settings/git/monitoring-rules/${integrationId}?isOrgSettings=true`
  },
  GIT_SERVICES: {
    path: '/settings/git/services'
  },
  NOTIFICATIONS: {
    path: '/settings/notifications'
  },
  PROJECT_MANAGEMENT: {
    path: '/settings/project-management'
  },
  PROJECT_MANAGEMENT_TOOLS: {
    path: '/settings/project-management/:managementTool?'
  },
  PROJECT_MANAGEMENT_PROJECTS: {
    path: '/settings/project-management/projects'
  },
  JIRA_CONNECT: {
    path: '/settings/jira'
  },
  SLACK: {
    path: '/settings/slack'
  },
  MSTEAMS: {
    path: '/settings/msteams'
  },
  TEAM_INSIGHTS: {
    path: '/settings/teaminsights'
  },
  USERS: {
    path: '/settings/users'
  },
  USERS_PERMISSIONS: {
    path: '/settings/users/permissions/:id'
  },
  USERS_PERMISSIONS_MULTIPLE: {
    path: '/settings/users/permissions'
  },
  USERS_INVITE_USER: {
    path: '/settings/users/inviteUser'
  },
  API_TOKENS: {
    path: '/settings/api-tokens'
  },
  SINGLE_SIGN_ON: {
    path: '/settings/authentication/single-sign-on'
  },
  AUTHENTICATION_SETTINGS: {
    path: '/settings/authentication'
  },
  AUTHENTICATION_SETTINGS_SCIM_PROVISIONING: {
    path: '/settings/authentication/scim-provisioning'
  },
  CONTRIBUTORS_AND_TEAMS_SETTINGS: {
    path: '/settings/contributorsAndTeams'
  },
  USER_SETTINGS: {
    path: '/settings/contributorsAndTeams/users'
  },
  CONTRIBUTORS_SETTINGS: {
    path: '/settings/contributorsAndTeams/contributors'
  },
  TEAMS_SETTINGS: {
    path: '/settings/contributorsAndTeams/teams'
  },
  GROUPS_SETTINGS_ADD: {
    path: '/settings/contributorsAndTeams/groups/add'
  },
  TEAMS_SETTINGS_ADD: {
    path: '/settings/contributorsAndTeams/teams/add'
  },
  TEAMS_SETTINGS_EDIT: {
    path: '/settings/contributorsAndTeams/teams/:id'
  },
  TEAMS_CTA: {
    path: '/teams-cta'
  },
  PERFORMANCE: {
    path: '/performance',
    options: {
      showTeamPicker: true
    }
  },
  TEAM_GOALS: {
    path: '/team-goals',
    options: {
      showTeamPicker: true,
      showFilteredView: true
    }
  },
  TEAM_GOALS_DASHBOARD: {
    path: '/team-goals/:id'
  },
  PERFORMANCE_TEAM_GOALS_CTA: {
    path: '/team-goals-cta'
  },
  OAUTH_CALLBACK: {
    path: '/callback/:providerName'
  },
  CHALLENGE_CALLBACK: {
    path: '/public/:providerName/challenge_callback'
  },
  PAGE_SIGNUP: {
    path: '/signup'
  },
  PAGE_SUCCESS: {
    path: '/success'
  },
  INDIVIDUAL: {
    path: '/individual'
  },
  ACTIVITY: {
    path: '/activity',
    options: {
      showTeamPicker: true,
      scrollToTop: false
    }
  },
  PULL_REQUESTS: {
    path: '/activity/pull-requests'
  },
  RELEASES: {
    path: '/activity/releases'
  },
  INCIDENTS: {
    path: '/activity/incidents'
  },
  CONTRIBUTORS: {
    path: '/contributors',
    options: {
      showTeamPicker: true,
      showFilteredView: true
    }
  },
  INDIVIDUALS: {
    path: '/contributors/individuals'
  },
  TEAMS: {
    path: '/contributors/teams'
  },
  BRANCH: {
    path: '/activity/branch'
  },
  PULSE: {
    path: '/pulse',
    options: {
      showTeamPicker: true,
      AdditionalTopBarComponent: 'PulseIterationPicker',
      showMigrationStaleBanner: true
    }
  },
  ONBOARDING: {
    path: '/onboarding'
  },
  ADD_ORG: {
    path: '/onboarding/add-organization'
  },
  ADD_PROVIDER: {
    path: '/onboarding/add-provider'
  },
  VERIFY_PROVIDER: {
    path: '/onboarding/verify-provider'
  },
  ADD_REPOS: {
    path: '/onboarding/add-repositories'
  },
  PROCESSING: {
    path: '/onboarding/processing'
  },
  PERSONAL_IDENTIFICATION_FORM: {
    path: '/onboarding/identification-form'
  },
  PROJECTS: {
    path: '/pdt/projects'
  },
  PROJECTS_API: {
    path: '/pdt/projectsapi'
  },
  PROJECTS_API_ALL: {
    path: '/pdt/projectsapi/all'
  },
  PROJECTS_API_FAVORITES: {
    path: '/pdt/projectsapi/favorites'
  },
  PROJECT: {
    path: '/pdt/projects/:uuid'
  },
  PROJECT_API: {
    path: '/pdt/projectsapi/:uuid'
  },
  PROJECTS_RESOURCE_ALLOCATION_OVERVIEW: {
    path: '/pdt/resource-allocation-overview',
    options: {
      showMigrationStaleBanner: true
    }
  },
  PROJECTS_RESOURCE_ALLOCATION_CONFIG: {
    path: '/pdt/resource-allocation-overview/config'
  },
  PROJECTS_INVESTMENT_CARVING: {
    path: '/pdt/investment-carving',
    options: {
      showMigrationStaleBanner: true
    }
  },
  PROJECTS_INVESTMENT_CARVING_CONFIG: {
    path: '/pdt/investment-carving/config'
  },
  PROJECTS_FORECASTING_ROOT: {
    path: '/pdt/forecasting',
    options: {
      showMigrationStaleBanner: true
    }
  },
  PROJECTS_FORECASTING_FORECAST: {
    path: '/pdt/forecasting/forecast'
  },
  PROJECTS_PROJECT_PROGRESSION: {
    path: '/pdt/forecasting/project-progression'
  },
  PROJECTS_PROJECT_PROGRESSION_INSIGHTS_CONFIG: {
    path: '/pdt/forecasting/project-progression/insights/config'
  },
  PROJECTS_ROOT: {
    path: '/pdt',
    options: {
      showMigrationStaleBanner: true
    }
  },
  INVALID_FILTER_SET: {
    path: '/invalid-filter-set'
  },
  PROJECTS_API_DEPRECATED: {
    // for redirecting old path to new path if someone store the old url
    path: '/projectsapi'
  },
  SEND_INVITATION: {
    path: '/send-invitation'
  },
  EMAIL_PREFERENCES: {
    path: '/email-preferences'
  },
  EMAIL_PREFERENCES_SETTINGS: {
    path: '/settings/email-preferences'
  },
  SIGN_UP: {
    path: '/sign-up'
  },
  NO_TEAMS: {
    path: '/no-teams'
  },
  RELOGIN_SYSTEM: {
    path: '/relogin-system'
  },
  /**
   * Federated apps
   */
  AUTOMATIONS: {
    path: '/automations',
    options: {
      showDatePicker: true,
      showTeamPicker: true,
      disableTeamPicker: true
    }
  },
  AUTOMATIONS_EXPLORATIONS: {
    path: '/automations/explore/add-label', // Need to change this to be more granular and support
    options: {
      showDatePicker: true,
      showTeamPicker: true,
      disableTeamPicker: true
    }
  },
  MARKETPLACE: {
    path: '/automations/marketplace',
    options: {
      showDatePicker: true,
      showTeamPicker: true,
      disableDatePicker: true,
      disableTeamPicker: true
    }
  },
  DEV_COACHING: {
    path: '/dev-coaching',
    options: {
      showDatePicker: true,
      showTeamPicker: true,
      show30daysMessage: true,
      showMigrationStaleBanner: true
    }
  },
  PRODUCTIVITY_GAIN: {
    path: '/productivity',
    options: {
      showDatePicker: true,
      showTeamPicker: false
    }
  },
  SURVEYS_EXECUTION: {
    path: '/surveys/execute/'
  },
  SURVEYS_LIST: {
    path: '/surveys/list'
  },
  SURVEYS: {
    path: '/surveys/*'
  }
});
export default AppRouter;
